import blogList from '../data/blogPosts';
import { t, Lang } from './i18n';

export interface LocalizedBlogItem {
	id: number;
	image: string;
	date: string;
	categoryText: string;
	title: string;
	excerpt: string;
	link: string;
}

export function getLocalizedBlogItems(lang: Lang): LocalizedBlogItem[] {
	return [...blogList]
		.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
		.map((p) => ({
			id: p.id,
			image: p.image,
			date: p.date,
			categoryText: t(lang, `blog.posts.${p.id}.category`) as string,
			title: t(lang, `blog.posts.${p.id}.title`) as string,
			excerpt: t(lang, `blog.posts.${p.id}.excerpt`) as string,
			link: `/${lang}/blog/${p.id}`,
		}));
}
